import { ConfigOverviewView as Overview } from './Overview';
import { ConfigPaymentView as Payment } from './Payment';
import {ConfigPaymentsView as Payments } from './Payments';
import {ConfigReceiptView as Receipt } from './Receipt';
import {ConfigPayView as Pay } from './Pay';

export { Overview, Payments, Receipt, Pay }
export default Payment;